<div class="layout-topbar p-shadow-4">
  <div class="layout-topbar-left">
    <a class="layout-topbar-logo" routerLink="/">
      <img id="app-logo" src="assets/layout/images/logo_vnpost.png" alt="ultima-layout" style="height: 3.25rem">
    </a>

    <a class="layout-menu-button shadow-6" (click)="appMain.onMenuButtonClick($event)" pRipple>
      <i class="pi pi-chevron-right"></i>
    </a>

    <a class="layout-topbar-mobile-button" (click)="appMain.onTopbarMobileButtonClick($event)" pRipple>
      <i class="pi pi-ellipsis-v fs-large"></i>
    </a>
  </div>

  <div class="layout-topbar-right" [ngClass]="{'layout-topbar-mobile-active': appMain.mobileTopbarActive}">
    <div class="layout-topbar-actions-left">
      <!-- <p-megaMenu [model]="model" styleClass="layout-megamenu"></p-megaMenu> -->
    </div>
    <div class="layout-topbar-actions-right">
      <ul class="layout-topbar-items">
        <li class="layout-topbar-item notifications">
          <a class="layout-topbar-action rounded-circle" (click)="appMain.onTopbarItemClick($event, 'notifications')"
            pRipple>
            <span class="p-overlay-badge">
              <i class="pi pi-bell fs-large"></i>
              <span class="p-badge p-badge-warning p-badge-dot" *ngIf="dataSource.length > 0"></span>
            </span>
          </a>

          <ul class="layout-topbar-action-panel shadow-6" [@topbarActionPanelAnimation]="'visible'"
            *ngIf="appMain.activeTopbarItem === 'notifications'">
            <li class="mb-3">
              <p-button label="{{'USERINFO.NOTIFICATIONS.COUNT' | translate : {count: totalUnRead} }}"
                (click)="goNotification()" styleClass="p-button-link p-mr-2 p-px-3 fs-small"></p-button>
            </li>
            <ng-template ngFor let-item [ngForOf]="dataSource">
              <li class="layout-topbar-action-item">
                <div class="flex flex-row p-ai-center" (click)="readItem(item)">
                  <div class="ci ci-chat"></div>
                  <div class="flex flex-column" [ngClass]="{'ml-3': !app.isRTL, 'mr-3': app.isRTL}"
                    style="flex-grow: 1;">
                    <div class="p-d-flex p-ai-center p-jc-between p-mb-1">
                      <span class="fs-small" [class.p-text-bold]="!item.isRead">{{item.title}}</span>
                    </div>
                    <span class="fs-small">{{item.created | timeAgo}}</span>
                  </div>
                </div>
              </li>
            </ng-template>
          </ul>
        </li>
        <li class="layout-topbar-item">
          <a class="layout-topbar-action p-d-flex p-dir-row p-jc-center p-ai-center p-px-2 rounded-circle"
            (click)="appMain.onTopbarItemClick($event, 'profile')" pRipple>
            <img src="assets/images/avatar-default.png" alt="avatar" style="width: 32px; height: 32px;">
          </a>

          <ul class="layout-topbar-action-panel shadow-6" [@topbarActionPanelAnimation]="'visible'"
            *ngIf="appMain.activeTopbarItem === 'profile'">
            <li class="layout-topbar-action-item">
              <a class="flex flex-row p-ai-center" pRipple [routerLink]="['/core/myprofile']">
                <i class="pi pi-cog" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{'USERINFO.MNU_INFO' | translate}}</span>
              </a>
            </li>
            <!-- <li class="layout-topbar-action-item">
              <a class="flex flex-row p-ai-center" pRipple [routerLink]="['/core/notifications']">
                <i class="pi pi-bell" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{'USERINFO.NOTIFICATIONS' | translate}}</span>
              </a>
            </li> -->
            <li class="layout-topbar-action-item" (click)="appMain.onLogout()">
              <a class="flex flex-row p-ai-center" pRipple>
                <i class="pi pi-power-off" [ngClass]="{'mr-2': !app.isRTL, 'ml-2': app.isRTL}"></i>
                <span>{{'USERINFO.MNU_LOGOUT' | translate}}</span>
              </a>
            </li>
            <li class="layout-topbar-action-item">
              <p-button styleClass="p-button-text  mr-2 mb-2" *ngFor="let item of dsLanguage"
                pTooltip=" {{item.code | translate}}" (click)="changeLang(item.code)">
                <ng-template pTemplate="content">
                  <img src="{{item.imageUrl}}" alt="">
                </ng-template>
              </p-button>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>
